import { render, staticRenderFns } from "./agilityTab.vue?vue&type=template&id=0e4e0b75&scoped=true&"
import script from "./agilityTab.vue?vue&type=script&lang=js&"
export * from "./agilityTab.vue?vue&type=script&lang=js&"
import style0 from "./agilityTab.vue?vue&type=style&index=0&id=0e4e0b75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e0b75",
  null
  
)

export default component.exports